import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var resolveParamsForS3 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(endpointParams) {
    var bucket;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            bucket = (endpointParams === null || endpointParams === void 0 ? void 0 : endpointParams.Bucket) || "";
            if (typeof endpointParams.Bucket === "string") {
              endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
            }
            if (!isArnBucketName(bucket)) {
              _context.next = 7;
              break;
            }
            if (!(endpointParams.ForcePathStyle === true)) {
              _context.next = 5;
              break;
            }
            throw new Error("Path-style addressing cannot be used with ARN buckets");
          case 5:
            _context.next = 8;
            break;
          case 7:
            if (!isDnsCompatibleBucketName(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) {
              endpointParams.ForcePathStyle = true;
            }
          case 8:
            if (endpointParams.DisableMultiRegionAccessPoints) {
              endpointParams.disableMultiRegionAccessPoints = true;
              endpointParams.DisableMRAP = true;
            }
            return _context.abrupt("return", endpointParams);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function resolveParamsForS3(_x) {
    return _ref.apply(this, arguments);
  };
}();
var DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var DOTS_PATTERN = /\.\./;
export var DOT_PATTERN = /\./;
export var S3_HOSTNAME_PATTERN = /^(.+\.)?s3(-fips)?(\.dualstack)?[.-]([a-z0-9-]+)\./;
export var isDnsCompatibleBucketName = function isDnsCompatibleBucketName(bucketName) {
  return DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
};
export var isArnBucketName = function isArnBucketName(bucketName) {
  var _bucketName$split = bucketName.split(":"),
    _bucketName$split2 = _slicedToArray(_bucketName$split, 6),
    arn = _bucketName$split2[0],
    partition = _bucketName$split2[1],
    service = _bucketName$split2[2],
    bucket = _bucketName$split2[5];
  var isArn = arn === "arn" && bucketName.split(":").length >= 6;
  var isValidArn = Boolean(isArn && partition && service && bucket);
  if (isArn && !isValidArn) {
    throw new Error("Invalid ARN: ".concat(bucketName, " was an invalid ARN."));
  }
  return isValidArn;
};